import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OrderSummary } from '../../api-client';

// Define a type for the slice state
interface CustomerOrdersState {
    orderSummary: OrderSummary[]
}

// Define the initial state using that type
const initialState: CustomerOrdersState = {
    orderSummary: []
}

export const customerOrdersSlice = createSlice({
    name: 'customerOrders',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        initCustomerOrders: (state, action: PayloadAction<OrderSummary[]>) => {
            state.orderSummary = action.payload;
        }
    }
});

export const { initCustomerOrders } = customerOrdersSlice.actions;

export default customerOrdersSlice.reducer;